import React from 'react';
import { connect } from 'react-redux';
import { DateInput } from 'semantic-ui-calendar-react';
import { Button, Checkbox, Dropdown, Form, Grid, Icon, Label, Radio, Select } from 'semantic-ui-react';
import { mapToSelect } from '../../api/egm';
import { updateAnalysisView } from '../../redux/actions';
import { confirmModal } from '../../redux/actions/modals';

const AnalysisFilters = (props) => {

    const onChange = (e, { name, value }) => props.updateAnalysisView({ [name]: value })

    const onDateChange = (e, { name, value }) => props.updateAnalysisView({ [name]: value })
    
    const onSelectAllChange = (allKey, selectedKey) => {
        const all = props.analysis[allKey].filter(x => x.name !== "All");
        const selected = props.analysis[selectedKey];
        
        console.log(selected)
        console.log(all)

        props.updateAnalysisView({ [selectedKey]: selected.length < all.length ? [...all.map(x => x.id)] : [] })
    }

    const onMultiSelectChange = (key, item) => {
        const selections  = props.analysis[key];
        if (selections.includes(item)) {
            props.updateAnalysisView({ [key]: selections.filter(x => x !== item) });
        } else {
            props.updateAnalysisView({ [key]: [...selections, item] });
        }
    }

    const {startDate, endDate, categories, measures, dataGroups, daysOfWeek, totalBy, timeGroupBy, selectedCategory, selectedTotalBy, selectedTimeGroupBy, selectedDayOfWeek, selectedMeasure, selectedDataGroup } = props.analysis;
    const { displayDayOfWeek, displayDataType, displayTotalOptions } = timeGroupBy.find(x => x.id === selectedTimeGroupBy) || { displayDataType: false, displayDayOfWeek: false, displayTotalOptions: false };
    const { site, company, subcompany } = props.analysisFilters.filterSelected;

    let selection = "All";
    if (company.id) selection = "CO";
    if (subcompany.id) selection = "SUB";
    if (site.id) selection = "SI";

    const processedGroups = dataGroups.filter(group => {
        return group.orgFilter.split(",").includes(selection) || group.orgFilter == ""
    })

    const disabled = !props.analysisFilters.hasSelection;

    const processedDaysOfWeek = daysOfWeek.filter(x => x.name !== "All");
    return (
        <>
        <Form>
            <Form.Group className="mb-0_5">
                    <DateInput
                        name="startDate"
                        disabled={disabled}
                        value={startDate}
                        iconPosition="right"
                        onChange={onDateChange}
                        animation="fade"
                        popupPosition="bottom center"
                        closable
                        width="3"
                        label="From"
                        inlineLabel={false}
                        autoComplete="off"
                    />
                    <DateInput
                        label="To"
                        inlineLabel={false}
                        name="endDate"
                        disabled={disabled}
                        width="3"
                        value={endDate}
                        iconPosition="right"
                        onChange={onDateChange}
                        animation="fade"
                        popupPosition="bottom center"
                        closable
                        autoComplete="off"
                    />
                <Form.Field width="2">
                    <label>Data View</label>
                    <Dropdown
                        compact
                        selection
                        options={mapToSelect(timeGroupBy)}
                        disabled={disabled}
                        value={selectedTimeGroupBy}
                        name="selectedTimeGroupBy"
                        onChange={onChange}
                    />
                </Form.Field>

            {displayDataType &&
                <Form.Field width="2">
                    <label>Data Type</label>
                    <Dropdown
                        selection
                        compact
                        options={mapToSelect(measures)}
                        disabled={disabled}
                        value={selectedMeasure}
                        name="selectedMeasure"
                        onChange={onChange}
                    />
                </Form.Field>
            }
                <Form.Field width="3">
                    <label>Group By</label>
                        <Dropdown
                            selection
                            compact
                            options={mapToSelect(processedGroups)}
                            disabled={disabled}
                            value={selectedDataGroup}
                            name="selectedDataGroup"
                            onChange={onChange}
                        />
                </Form.Field>
            {displayTotalOptions &&
            <Form.Field width="2">
                <label>Aggregation</label>
                <Dropdown
                    selection
                    compact
                    name="selectedTotalBy"
                    options={mapToSelect(totalBy)}
                    value={selectedTotalBy}
                    onChange={onChange}
                />

</Form.Field>
            }

        <Dropdown scrolling disabled={disabled} compact as={Button} color='teal' icon="filter" className='icon mt-1_5'>
            <Dropdown.Menu>
            {displayDayOfWeek &&
                <>
                    <Dropdown.Header onClick={(e) => { e.stopPropagation(); onSelectAllChange("daysOfWeek", "selectedDayOfWeek") }}>
                        <Icon style={{ fontSize: "1rem", marginRight: "0.7857rem"}} name={processedDaysOfWeek.length === selectedDayOfWeek.length ? "check square" : "check square outline"} color={processedDaysOfWeek.length === selectedDayOfWeek.length ? "green" : "grey"} />    
                        Day Of Week
                    </Dropdown.Header>
                    {daysOfWeek.filter(x => x.name !== "All").map(option => {
                        const isSelected = selectedDayOfWeek.includes(option.id);
                        return <Dropdown.Item onClick={(e) => { e.stopPropagation(); onMultiSelectChange("selectedDayOfWeek", option.id) }}><Icon name={isSelected ? "check square" : "check square outline"} color={isSelected ? "green" : "grey"} /> {option.name}</Dropdown.Item>

                    })}
                    <Dropdown.Divider />
                </>
            }

            <>
                <Dropdown.Header onClick={(e) => { e.stopPropagation(); onSelectAllChange("categories", "selectedCategory") }}>
                    <Icon style={{ fontSize: "1rem", marginRight: "0.7857rem" }} name={categories.length === selectedCategory.length ? "check square" : "check square outline"} color={categories.length === selectedCategory.length ? "green" : "grey"} />
                    Category
                </Dropdown.Header>
                {categories.map(option => {
                    const isSelected = selectedCategory.includes(option.id);
                    return <Dropdown.Item onClick={(e) => { e.stopPropagation(); onMultiSelectChange("selectedCategory", option.id) }}><Icon name={isSelected ? "check square" : "check square outline"} color={isSelected ? "green" : "grey"} /> {option.name}</Dropdown.Item>
                })}
                { (displayTotalOptions && totalBy.length > 0) && <Dropdown.Divider /> }
            </>


            </Dropdown.Menu>
        </Dropdown>

            <Button content="Process" compact className="mt-1_5" positive onClick={props.onRefresh} disabled={disabled} />
                <Button compact className="mt-1_5 mr-0" onClick={props.onExport} icon="download" color="blue" disabled={disabled} />
            </Form.Group>
        </Form>
        
        <div className="ml-0_5 mr-1">
             <b>Day Of Week:</b> { selectedDayOfWeek.length === processedDaysOfWeek.length ? 
                <Label>ALL</Label>
            :
                selectedDayOfWeek.length > 0 ? processedDaysOfWeek.filter(day => selectedDayOfWeek.includes(day.id)).map(day => <Label>{day.name}</Label>) : <Label>NONE</Label>
            }
             <b className="ml-1">Category:</b> { selectedCategory.length === categories.length ? 
                <Label>ALL</Label>
            :
                selectedCategory.length > 0 ? categories.filter(cat => selectedCategory.includes(cat.id)).map(cat => <Label>{cat.name}</Label>) : <Label>NONE</Label>
            }
        </div>

         
        </>
    )
}

const mapStateToProps = state => {
	return {
    analysis: state.analysisView,
    analysisFilters: state.analysisFilters
  };
};

export default connect(mapStateToProps, { updateAnalysisView, confirmModal })(AnalysisFilters);
